<div class="filter-group" [class.row]="isRow" [class]="customizedClasses">
    <ng-container *ngFor="let status of statusCounts">
        <div *letVar="isActiveFilter(status.key) as isActive" class="status-checkbox customized-checkbox" [class.active]="isActive">
            <mat-checkbox id="status-{{ status.key }}-ckx" [checked]="isActive" (change)="onFilterChange(status.key)">
                {{ status.display }}
            </mat-checkbox>
            <span class="status-display">({{ status.value || 0 }})</span>
        </div>
    </ng-container>
</div>
